import React, { useMemo } from 'react';

import { CareerOutcomes } from './CareerOutcome';
import { SchoolOutcomes } from './SchoolOutcome';
import { TestOutcomes } from './TestOutcome';
import {
  type OutcomesCareerOutcomeSummaryFragment,
  type OutcomesOutcomesFragment,
  type OutcomesSchoolOutcomeSummaryFragment,
  type OutcomesTestOutcomeSummaryFragment,
} from './__generated-gql-types__/Outcomes.generated';

interface OutcomesProps {
  outcomes: OutcomesOutcomesFragment[];
  coachName: Possible<string>;
}

export const Outcomes: React.FC<OutcomesProps> = ({ outcomes, coachName }) => {
  const { schoolOutcomes, careerOutcomes, testOutcomes } = useMemo(() => {
    const outcomesObj: {
      schoolOutcomes?: OutcomesSchoolOutcomeSummaryFragment;
      careerOutcomes?: OutcomesCareerOutcomeSummaryFragment;
      testOutcomes?: OutcomesTestOutcomeSummaryFragment[];
    } = { testOutcomes: [] };

    outcomes.forEach((outcome) => {
      if (outcome.__typename === 'SchoolOutcomeSummary') {
        outcomesObj.schoolOutcomes = outcome;
      } else if (outcome.__typename === 'CareerOutcomeSummary') {
        outcomesObj.careerOutcomes = {
          ...outcome,
          companies: outcome.companies.filter((s) => s.name !== 'N/A'),
        };
      } else if (
        outcome.__typename === 'TestOutcomeSummary' &&
        outcome?.scoreRange
      ) {
        outcomesObj.testOutcomes?.push(
          outcome as OutcomesTestOutcomeSummaryFragment,
        );
      }
    });

    return outcomesObj;
  }, [outcomes]);

  return (
    <div>
      {schoolOutcomes ? (
        <>
          <hr className="my-6" />
          <SchoolOutcomes
            outcomes={schoolOutcomes}
            coachName={coachName}
            truncateAfterLines={3}
            isButtonBelowLogos
          />
        </>
      ) : null}
      {careerOutcomes ? (
        <>
          <hr className="my-6" />
          <CareerOutcomes
            outcomes={careerOutcomes}
            coachName={coachName}
            truncateAfterLines={3}
            isButtonBelowLogos
          />
        </>
      ) : null}
      {testOutcomes?.length
        ? testOutcomes.map((outcome) => {
            return outcome ? (
              <div key={outcome.category.name}>
                <hr className="my-6" />
                <TestOutcomes outcome={outcome} coachName={coachName} />
              </div>
            ) : null;
          })
        : null}
    </div>
  );
};
